import React, { Fragment } from 'react';
import ArticlePage from '../../platformui/Pages/article';
import * as Render from '../../platformui/Base/Render';
import ChapterBlock from '../../blocks/chapter-block';
import ImageBlock from '../../blocks/image-block';
import ChapterContainerBlock from '../../blocks/chapter-container-block';
import LinkCollectionBlock from '../../blocks/link-list-block';
import ManuelPageListBlock from '../../blocks/manuel-page-list-block';
import ListContainerBlock from '../../blocks/list-container-block';
import SearchLinkListBlock from '../../blocks/search-link-list-block';
import HighlightBlock from '../../blocks/highlight-block';
import VideoBlock from '../../blocks/video-block';
import PowerBIBlock from '../../blocks/power-bi-block';
import EpiserverFormsBlock from '../../blocks/episerver-forms-block';
import AnchorNav from '../../components/anchor-nav';
import withAnchorNav from '../../platformui/Containers/withAnchorNav';
import SearchArticleListBlock from '../../blocks/search-article-list-block';
import AOListBlock from '../../blocks/ao-list-block';
import ReadingAidBlock from '../../blocks/reading-aid-block';
import DoubleColumnBlock from '../../blocks/double-column-block';
import SlideshowBlock from '../../blocks/slideshow-block';
import DescriptionListBlock from '../../blocks/description-list-block';
import { VideoContainerBlock } from '../../blocks';
import MatomoTrackDataAttribute from '../../platformui/Matomo/matomo-track-data-attribute';
import MatomoTrackMediaAnalytics from '../../platformui/Matomo/matomo-track-media-analytics';

const Blocks = {
  ChapterBlock,
  ChapterContainerBlock,
  ImageBlock,
  LinkCollectionBlock,
  ManuelPageListBlock,
  ListContainerBlock,
  SearchLinkListBlock,
  HighlightBlock,
  VideoBlock,
  PowerBIBlock,
  EpiserverFormsBlock,
  SearchArticleListBlock,
  AOListBlock,
  ReadingAidBlock,
  DescriptionListBlock,
  DoubleColumnBlock,
  SlideshowBlock,
  VideoContainerBlock,
};

const blockTypes = <Render.BlockTypeRenderer Blocks={Blocks} />;

const ArticlePageInera = (props) => {
  return (
    <Fragment>
      <ArticlePage
        {...props}
        MainContentGrid={
          props.isWideArticlePage ? 'columns large-9' : undefined
        }
        SecondaryContentGrid={
          props.isWideArticlePage ? 'columns large-3' : undefined
        }
        SidebarGrid={
          props.isWideArticlePage
            ? 'columns large-3 show-for-large u-right-col'
            : undefined
        }
        BlockTypeRenderer={blockTypes}
        SubjectAboveHeading={true}
        RightColumnComponents={
          !props.Content.HideAnchorNavigation && (
            <AnchorNav
              Links={props.Content.AnchorNavigation}
              anchorHeading={props.Content.Translations.anchorheading}
              currentActiveMenuItem={(id) => props.currentActiveMenuItem(id)}
              currentActiveId={props.currentActiveId}
            />
          )
        }
      />
      <MatomoTrackMediaAnalytics />
      <MatomoTrackDataAttribute />
    </Fragment>
  );
};

export default withAnchorNav(ArticlePageInera);
